(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vanta-product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    let saved = [];
    try {
      saved = JSON.parse(localStorage.getItem('saved-products') || '[]');
    } catch (err) {
      saved = [];
    }

    document.querySelectorAll('[data-product-card-save]').forEach((btn) => {
      if (saved.indexOf(btn.dataset.productId) > -1) btn.classList.add('is-saved');

      btn.addEventListener('click', () => {
        btn.classList.toggle('is-saved');
        try {
          const key = 'saved-products';
          const current = JSON.parse(localStorage.getItem(key) || '[]');
          const id = btn.dataset.productId;
          const index = current.indexOf(id);
          if (index > -1) {
            current.splice(index, 1);
          } else {
            current.push(id);
          }
          localStorage.setItem(key, JSON.stringify(current));
        } catch (err) {
          // localStorage unavailable — save is purely visual this session
        }
      });
    });

    document.querySelectorAll('[data-product-card]').forEach((card) => {
      const pills = card.querySelectorAll('[data-product-card-variants] [data-variant-id]');
      if (!pills.length) return;

      const currencyCode = card.dataset.currencyCode || 'USD';
      const i18nInStock = card.dataset.i18nInStock || 'In stock';
      const i18nComingSoon = card.dataset.i18nComingSoon || 'Coming soon';

      const priceEl = card.querySelector('[data-product-card-price]');
      const compareEl = card.querySelector('[data-product-card-compare]');
      const stockEl = card.querySelector('[data-product-card-stock]');
      const stockTextEl = card.querySelector('[data-product-card-stock-text]');
      const addBtn = card.querySelector('.product-card__cta--add');
      const notifyBtn = card.querySelector('.product-card__cta--notify');

      function formatMoney(amount) {
        return Number(amount).toLocaleString(undefined, { style: 'currency', currency: currencyCode });
      }

      pills.forEach((pill) => {
        pill.addEventListener('click', () => {
          if (pill.classList.contains('is-unavailable')) return;

          pills.forEach((p) => p.classList.remove('is-selected'));
          pill.classList.add('is-selected');

          const available = pill.dataset.available === 'true';
          const price = parseFloat(pill.dataset.price) / 100;
          const compareAt = parseFloat(pill.dataset.compareAtPrice) / 100;

          if (priceEl) priceEl.textContent = formatMoney(price);
          if (compareEl) {
            if (compareAt > price) {
              compareEl.textContent = formatMoney(compareAt);
              compareEl.hidden = false;
            } else {
              compareEl.hidden = true;
            }
          }

          if (stockEl) {
            stockEl.classList.toggle('is-available', available);
            stockEl.classList.toggle('is-unavailable', !available);
          }
          if (stockTextEl) stockTextEl.textContent = available ? i18nInStock : i18nComingSoon;

          if (addBtn) {
            addBtn.hidden = !available;
            addBtn.dataset.cartAddVariant = pill.dataset.variantId;
          }
          if (notifyBtn) notifyBtn.hidden = available;
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
